export default "__VITE_ASSET__13ebd987__"